import axiosInstance from './axios-instance';

export const checkFeedback = (uniqueId: string) =>
  axiosInstance.get('/feedback/check', { params: { uniqueId } });

export const createFeedback = (uniqueId: string, payload: unknown) =>
  axiosInstance.post('/feedback', payload, { params: { uniqueId } });
